import { render } from "./BasicModal.vue?vue&type=template&id=fc8c4090&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"

import "./BasicModal.vue?vue&type=style&index=0&id=fc8c4090&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8c4090"]])

export default __exports__